<script>
  export default {
    name: 'contact-card',
    data: () => ({
      contacts: [
        // {
        //   department: 'Director',
        //   extension: '7',
        //   contact: 'Matthew Wuthenow'
        // },
        // {
        //   department: 'Assistant Director',
        //   extension: '8',
        //   contact: 'Deborah Elwarari'
        // },
        {
          department: 'Public Relations',
          extension: '123',
          supervisor: 'Judy Moccio '
        },
        {
          department: 'Reference',
          extension: '5',
          supervisor: 'Kassia Plotke'
        },
        {
          department: 'Childrens',
          extension: '6',
          supervisor: 'Lauren Scottaline'
        },
        {
          department: 'Circulation',
          extension: '4',
          supervisor: 'Pam Fitzsimmons'
        },
        {
          department: 'Accounting Department',
          extension: '122',
          supervisor: 'Andrea Smith'
        },
        {
          department: 'Technical Services',
          extension: '121',
          supervisor: 'Debbie Russin'
        }
      ]
    })
  }
</script>

<template>
  <v-card max-width="700" width="100%" class="mt-16">
    <v-app-bar color="primary" dark>
      <v-toolbar-title class="text-h5 font-weight-bold">Contact</v-toolbar-title>
    </v-app-bar>
    <v-card-text class="card-text primary--text font-weight-bold">
      <v-row>
        <v-col cols="12" sm="6">
          <v-btn block color="primary"> <v-icon left>mdi-phone</v-icon> (631) 581-9200 </v-btn>
        </v-col>
        <v-col cols="12" sm="6">
          <v-btn block color="primary"> <v-icon left>mdi-mail</v-icon> help@eipl.org </v-btn>
        </v-col>
      </v-row>
      <v-list two-line>
        <template v-for="contact in contacts">
          <v-list-item :key="contact.extension" class="px-0">
            <v-list-item-content>
              <v-list-item-title class="primary--text text-body-1 font-weight-bold">{{ contact.department }}</v-list-item-title>
              <v-list-item-subtitle class="text-body-2 font-weight-bold"> {{ contact?.supervisor ? `Supervisor: ${contact.supervisor}` : contact.contact }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action class="primary--text">
              <v-list-item-action-text> Ext: </v-list-item-action-text>
              {{ contact.extension }}
            </v-list-item-action>
          </v-list-item>
          <v-divider v-if="contact.extension !== '121'" :key="contact.extension + 'd'"></v-divider>
        </template>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<style scoped>
  /* .card-text {
    height: 520px;
    overflow-y: auto;
  } */
</style>
